import { render, staticRenderFns } from "./Release.vue?vue&type=template&id=13bf6b26&scoped=true&"
import script from "./Release.vue?vue&type=script&lang=ts&"
export * from "./Release.vue?vue&type=script&lang=ts&"
import style0 from "./Release.vue?vue&type=style&index=0&id=13bf6b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf6b26",
  null
  
)

export default component.exports